import Modal from "../Modal.jsx";
import { Artwork, Icon } from "./Media.jsx";

/** 將歌曲加入播放列表、收藏或自建歌單的單一入口。 */
export default function AddDestinationSheet({
  song,
  playlists,
  favorite,
  onClose,
  onAddQueue,
  onAddFavorite,
  onAddPlaylist,
  onCreatePlaylist,
}) {
  if (!song) return null;
  return (
    <Modal label="選擇加入位置" onClose={onClose}>
      <section className="destination-sheet">
        <div className="destination-head">
          <div><span>加入歌曲</span><strong>選擇儲存位置</strong></div>
          <button type="button" onClick={onClose} aria-label="關閉"><Icon name="close" size={19}/></button>
        </div>
        <div className="destination-song">
          <Artwork song={song} className="destination-art" />
          <span><strong>{song.title || "未命名歌曲"}</strong>
            <small>{(song.artists || []).join("、") || "未知演出者"}</small></span>
        </div>
        <div className="destination-primary">
          <button type="button" onClick={() => { onAddQueue(song); onClose(); }}>
            <span className="destination-icon"><Icon name="list" size={19}/></span>
            <span><strong>播放列表</strong><small>加入接下來播放的歌曲</small></span>
            <Icon name="plus" size={17}/>
          </button>
          <button type="button" onClick={() => { onAddFavorite(song); onClose(); }}>
            <span className="destination-icon"><Icon name="heart" size={19} filled={favorite}/></span>
            <span><strong>我的收藏</strong><small>{favorite ? "這首歌已經收藏" : "保存到我的收藏"}</small></span>
            <Icon name={favorite ? "heart" : "plus"} size={17} filled={favorite}/>
          </button>
        </div>
        <div className="destination-playlists">
          <div className="destination-section-title">
            <span>自建歌單</span>
            <button type="button" onClick={() => onCreatePlaylist(song)}><Icon name="plus" size={14}/>新增歌單</button>
          </div>
          <div className="destination-playlist-list">
            {playlists.map((playlist) => (
              <button key={playlist.id} type="button"
                onClick={() => { onAddPlaylist(song, playlist.id); onClose(); }}>
                <span className="destination-icon"><Icon name="music" size={17}/></span>
                <span><strong>{playlist.name}</strong><small>{playlist.songs.length} 首歌曲</small></span>
                <Icon name="plus" size={16}/>
              </button>
            ))}
          </div>
        </div>
      </section>
    </Modal>
  );
}
